import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import round from 'lodash/round';
import { Link as ScrollLink } from 'react-scroll';
import floor from 'lodash/floor';

import SpecialFormattedNumber from 'Components/Utility/Price/SpecialFormattedNumber';

import 'Features/Bundle/components/PayWhatYouWant/DonationTotal.scss';

export default function DonationTotal({ soldOut, charity }) {
  if (isEmpty(charity)) return false;
  const { amount, name, donation_link: donationLink, leaders } = charity;

  let topDonater = null;
  if (!isEmpty(leaders)) {
    topDonater = leaders[0];
  }

  if ((amount < 1000 || isNaN(amount)) && !soldOut) return false;

  return (
    <div className={classNames('DonationTotal', { soldOut })}>
      <div className="DonationTotal-Heading">
        <span className="DonationTotal-Heading_large">
          <SpecialFormattedNumber hideDecimals value={floor(amount)} currency="USD" />
        </span>
        {!soldOut &&
          <FormattedMessage
            id="DonationTotal.Heading.donated-so-far"
            defaultMessage="Donated so far"
          />
        }
        {soldOut &&
          <FormattedMessage
            id="DonationTotal.Heading.donated"
            defaultMessage="Donated"
          />
        }
      </div>

      {topDonater &&
        <div className="DonationTotal-SubText">
          <div className="DonationTotal-SubText_copy-bold">
            <FormattedMessage
              id="DonationTotal.SubText.topdonation"
              defaultMessage="Top Donation: {topDonaterName} {topDonaterPrice}"
              values={{
                topDonaterName: <span className="pr-1">{topDonater.leaderboard_name}</span>,
                topDonaterPrice: <span className="pr-2"><SpecialFormattedNumber
                  hideDecimals
                  value={round((get(topDonater, 'value', 0) / 100), 2)}
                  currency={topDonater.currency}
                /></span>,
                charityName: <span className="DonationTotal-SubText_copy-bold">{name}</span>,
              }}
            />
          </div>
          <span>
            <b>
              <ScrollLink
                spy
                smooth
                activeClass="active"
                to="charity-leaderboard"
                duration={500}
                offset={-100}
                className="DonationTotal-SubText_copy-primary DonationTotal-SubText__anchor"
              >
                <FormattedMessage id="DonationTotal.viewleaderboard" defaultMessage="View Leaderboard" />
              </ScrollLink>
            </b>
          </span>
        </div>
      }

      {soldOut &&
        <React.Fragment>
          <div className="DonationTotal-SeperatorLine" />
          <div className="DonationTotal-SoldOut_title">
            <FormattedMessage
              id="DonationTotal.SoldOut.title"
              defaultMessage="Sorry, this bundle is now out of stock"
            />
          </div>
          <div className="DonationTotal-SoldOut_copy">
            {!donationLink &&
              <FormattedMessage
                id="DonationTotal.SoldOut.copynodonationlink"
                defaultMessage="Thank you to everyone who donated."
              />
            }
            {donationLink &&
              <FormattedMessage
                id="DonationTotal.SoldOut.copy"
                defaultMessage="Thank you to everyone who donated. If you missed out and would still like to donate to support the work of {charityName}, please {link} to go to their website."
                values={{
                  charityName: name,
                  link: <a href={donationLink} target="_blank" rel="noopener noreferrer nofollow" className="DonationTotal-SoldOut_copy-link"><FormattedMessage
                    id="DonationTotal.SoldOut.copy.link"
                    defaultMessage="Click Here"
                  /></a>,
                }}
              />
            }
          </div>
        </React.Fragment>
      }
    </div>
  );
}

DonationTotal.propTypes = {
  soldOut: PropTypes.bool,
  charity: PropTypes.shape({}),
};

DonationTotal.defaultProps = {
  soldOut: false,
  charity: {
    amount: 0,
  },
};
